import image1 from '../../../../assets/images/work/sn-nex/NEX_detailed_img_1.jpg';
import image2 from '../../../../assets/images/work/sn-nex/NEX_detailed_img_2.jpg';
import image4 from '../../../../assets/images/work/sn-nex/NEX_detailed_abovefooter.jpg';

import artwork from '../../../../assets/images/art_2.png';

const Data_SNNEX = {
    content: (
        <>
            {/* content */}
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">PROBLEM</h4>
                                    <div className="paragraph light-1">
                                        <p className="mb-5">
                                            Science North’s Nature Exchange has inspired hands on learning for more than
                                            two decades, but the experience was ready for a modern evolution. The
                                            program needed to expand beyond a single physical touchpoint and become a
                                            connected experience that could guide visitors before, during, and after
                                            they explore nature.
                                        </p>
                                        <p>
                                            The goal was to create a user friendly system that supports safe collecting
                                            practices, regional guidelines, and meaningful learning, while also giving
                                            the Science North team the tools to manage trades, content, and
                                            interactions at scale. Just as important, the new version needed to
                                            encourage participation even when certain nature items should not be
                                            removed, so visitors could still engage responsibly.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-6 second-column">
                                    <h4 className="heading heading-small light-2">CHALLENGES</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            Building a modern Nature Exchange meant balancing a few competing needs at
                                            once. The experience had to feel simple and inviting for families and
                                            students, while still being structured enough to support guidelines, point
                                            systems, trade history, and content moderation. We also needed to design
                                            the system around real world usage in the field where connectivity,
                                            lighting conditions, and quick capture moments matter.
                                        </p><br/>
                                        <p>
                                            On the operational side, the Science North team needed a reliable way to
                                            manage items, approve trades, publish events, and keep the experience
                                            fresh over time. The result needed to be scalable, secure, and easy to
                                            maintain as the program continues to grow across communities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="project-content">
                <div className="project-content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-large dark-1">
                                        A modern Nature Exchange that turns outdoor discovery into a guided learning
                                        journey, complete with responsible trading, personal progress, and tools for
                                        science teams to manage content at scale.
                                    </h2>

                                    <div className="paragraph dark-1">
                                        <p>
                                            The upgraded Nature Exchange experience was designed to meet people where
                                            exploration happens. Visitors can learn what to look for, how to collect
                                            safely, and how to follow regional guidelines, all while staying motivated
                                            through a points based trading system that rewards curiosity and good
                                            habits.
                                        </p>
                                    </div>

                                    <div className="heading heading-medium dark-1">
                                        <p>Strategy Session.</p>
                                    </div>

                                    <div className="paragraph dark-1">
                                        <p>
                                            We worked with Science North to map the full visitor journey, from planning
                                            a visit, to exploring outdoors, to returning for trades and learning. The
                                            key was to keep the experience user centered while creating a flexible
                                            content system behind the scenes. That meant building features that support
                                            trade logging, personal journals, badges, and event discovery, while also
                                            giving the science team control over approvals, learning content, and
                                            program updates.
                                        </p>
                                        <p><br/>
                                            We also introduced an important new interaction model for the modern
                                            version, photo based trading. This lets visitors engage with nature
                                            responsibly by photographing items that should not be removed, then
                                            completing a guided trade interaction with a Science North team member.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image-wrapper">
                        <div className="single-image">
                            <img src={image1} alt="project-detailed-2" />
                        </div>
                        <div className="single-image">
                            <img src={image2} alt="project-detailed-3" />
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-medium dark-1">Plan of Action.</h2>

                                    <div className="paragraph dark-1">
                                        <p>
                                            We delivered the front facing application experience and the underlying
                                            systems that make it sustainable long term. Users can discover upcoming
                                            events around the science centre, learn safe collecting practices, track
                                            trades, and build a personal journal for each item they submit. A badge and
                                            milestone system encourages continued exploration and helps make learning
                                            feel rewarding over time.
                                        </p><br/>
                                        <p>
                                            On the operational side, we built the system architecture and an
                                            administration portal so Science North teams can effectively manage the
                                            program. This includes tools to curate content, manage trade workflows,
                                            guide trading interactions with team members, and keep the experience
                                            updated as seasonal learning opportunities change.
                                        </p><br/>
                                        <p>
                                            The result is a modern platform that supports meaningful engagement with
                                            nature, makes discovery shareable with friends and family, and gives the
                                            science team the controls they need to deliver a consistent, trusted
                                            experience across communities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image">
                        <img src={image4} alt="project-detailed-4" />
                    </div>
                </div>
            </div>

            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">RESULTS</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            Science North now has a modern Nature Exchange platform that supports a
                                            complete learning journey, not just a single moment of trade. Visitors are
                                            guided toward responsible outdoor behavior, can participate even when items
                                            should remain in nature, and stay engaged through journals, badges, and
                                            ongoing content. Behind the scenes, science teams have the tools to manage
                                            trades, publish experiences, and keep the program evolving for years to
                                            come.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-5 offset-lg-1 second-column">
                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">
                                            <span>PLATFORM</span>
                                        </h4>
                                       <div className="paragraph light-1">
                                            <p>iOS, Android</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">
                                            <span>CLIENT</span>
                                        </h4>
                                       <div className="paragraph light-1">
                                            <p>Science North</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">ONLINE</h4>
                                        <div className="paragraph light-1">
                                            <p><a href="https://www.sciencenorth.ca/" target="_blank" rel="noreferrer">
                                                https://www.sciencenorth.ca
                                            </a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-content-footer">
                        <div className="container">
                            <div className="row align-items-lg-center">
                                <div className="col-md-6">
                                    <h3 className="heading heading-large light-1">
                                        Have an idea?
                                        <br />
                                        Let’s explore it together.
                                    </h3>
                                </div>
                                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                                    <div className="button-wrapper">
                                        <a className="button button-1" href="/Contact">
                                            Contact Us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="artwork artwork-2">
                        <img src={artwork} alt="artwork" />
                    </div>
                </div>
            </div>
        </>
    ),
};

export default Data_SNNEX;


